import React from 'react';

const defaultValue = {
  locale: 'he',
  setLocale: (v: string) => {
    console.log('lang', v);
  }
};

export default React.createContext(defaultValue);
